/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { animated, useSpring } from '@react-spring/web';

import { FormattedMessage } from 'react-intl';
import DrawnArrow from './DrawnArrow';

import heart from '../../../img/careers/heart.png';
import mic from '../../../img/careers/mic.png';
import prof from '../../../img/careers/prof.png';
import hatguy from '../../../img/careers/hatguy.png';
import leopard from '../../../img/careers/leopard.png';

import styles from '../../../styles/partials/career-page-header.module.scss';
import RoundedButton from '../buttons/Rounded';

const propTypes = {
    title: PropTypes.string,
    anchors: PropTypes.arrayOf(
        PropTypes.shape({ id: PropTypes.string, label: PropTypes.string, color: PropTypes.string }),
    ),
    onClick: PropTypes.func,
    pageHandle: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    anchors: null,
    onClick: null,
    pageHandle: null,
    className: null,
};

const CareerPageHeader = ({ title, anchors, onClick, pageHandle, className }) => {
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        setAnimate(false);
        const timeout = setTimeout(() => setAnimate(true), 100);
        return () => {
            clearTimeout(timeout);
            setAnimate(false);
        };
    }, [pageHandle]);

    const getStyle = useCallback((ratio) => {
        const opacityRatio = (100 - Math.round((window.scrollY / window.innerHeight) * 100)) / 100;
        return {
            y: window.scrollY / ratio,
            opacity: opacityRatio,
        };
    }, []);

    const [titleStyle, titleSpringApi] = useSpring(() => getStyle(4));
    const [frameStyle, frameSpringApi] = useSpring(() => getStyle(8));

    useEffect(() => {
        const onScroll = () => {
            titleSpringApi.start(getStyle(6));
            frameSpringApi.start(getStyle(8));
        };
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [titleSpringApi, frameSpringApi]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.animate]: animate,
                },
            ])}
        >
            {/* hidden title for accessibilty */}
            <h1 className={styles.hiddenTitle}>{title}</h1>
            <animated.div className={styles.title} style={titleStyle}>
                <h2>
                    <FormattedMessage
                        defaultMessage="Want to make the ordinary"
                        description="Career header"
                    />
                    <br />
                    <span className={styles.gradientText}>
                        <FormattedMessage
                            defaultMessage="extraordinary"
                            description="Career header emphasis"
                        />
                    </span>
                    <FormattedMessage defaultMessage="with us?" description="Career header" />
                </h2>
                <div className={styles.anchors}>
                    {(anchors || []).map(
                        ({ id = null, label = null, color = null, active = false }) => {
                            if (active) {
                                return (
                                    <RoundedButton
                                        key={`anchor-button-${id}`}
                                        onClick={onClick !== null ? () => onClick(id) : null}
                                        className={styles.anchor}
                                        style={{ backgroundColor: color !== null ? color : null }}
                                    >
                                        {label}
                                    </RoundedButton>
                                );
                            }
                        },
                    )}
                </div>
            </animated.div>
            <animated.div className={styles.frameContainer} style={frameStyle}>
                <img src={heart} alt={title} className={classNames([styles.image, styles.heart])} />
                <img src={prof} alt={title} className={classNames([styles.image, styles.prof])} />
                <img src={mic} alt={title} className={classNames([styles.image, styles.mic])} />
                <img
                    src={hatguy}
                    alt={title}
                    className={classNames([styles.image, styles.hatguy])}
                />
                <img
                    src={leopard}
                    alt={title}
                    className={classNames([styles.image, styles.leopard])}
                />
            </animated.div>
            <div className={styles.arrowContainer}>
                <DrawnArrow className={styles.arrow} onObserve />
            </div>
        </div>
    );
};

CareerPageHeader.propTypes = propTypes;
CareerPageHeader.defaultProps = defaultProps;

export default CareerPageHeader;
